import React, { useEffect, useState } from 'react';
import { ChatEngine } from 'react-chat-engine';

function SupportAdmin() {
  const [projectDetails, setProjectIdDetails] = useState('');
  const [forceRender, setForceRender] = useState(false); 

  var data = [
    { name: 'Visualpathedtech', value: '848e7770-4254-4434-a410-aebe391a88f5' },
    { name: 'k8sengineers', value: '848e7770-4254-4434-a410-aebe391a88f5' }
  ];

  const dataGet = (item) => {
    setProjectIdDetails(item);
  };

  useEffect(() => {
    setForceRender(prevState => !prevState);
  }, [projectDetails]);

  return (
    <>
      <div className="form-group mb-3 col-md-3">
        <div>
          <select className="form-control" onChange={(e) => dataGet(e.target.value!=''?JSON.parse(e.target.value):'')}>
            <option value=''>Select Tenant</option>
            {data.map((item, index) => (
              <option key={index} value={JSON.stringify(item)}>{item.name}</option>
            ))}
          </select>
        </div>
      </div>
      
      {projectDetails !== '' ? (
        <ChatEngine
          key={forceRender} 
          projectID={projectDetails.value}
          userName={projectDetails.name}
          userSecret='venu2000'
          height='calc(100vh - 12px)'
        />
      ) : (
        <h1 style={{ textAlign: 'center', marginTop: '10%', color: 'gray' }}>Please Select Tenant </h1>
      )}
    </>
  );
}

export default SupportAdmin;
